var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35527 2.28694L9.57227 0.460938L17.7893 2.28694C18.0113 2.3363 18.2099 2.4599 18.3523 2.63734C18.4946 2.81478 18.5722 3.03545 18.5723 3.26294V13.2499C18.5722 14.2377 18.3283 15.2101 17.8622 16.0809C17.396 16.9518 16.7221 17.6941 15.9003 18.2419L9.57227 22.4609L3.24427 18.2419C2.42254 17.6942 1.74873 16.952 1.28261 16.0814C0.816501 15.2107 0.572502 14.2385 0.572266 13.2509V3.26294C0.572305 3.03545 0.649904 2.81478 0.792255 2.63734C0.934607 2.4599 1.1332 2.3363 1.35527 2.28694ZM2.57227 4.06494V13.2499C2.57228 13.9084 2.73484 14.5567 3.04553 15.1372C3.35621 15.7178 3.80542 16.2127 4.35327 16.5779L9.57227 20.0579L14.7913 16.5779C15.339 16.2128 15.7881 15.718 16.0988 15.1377C16.4094 14.5573 16.5721 13.9092 16.5723 13.2509V4.06494L9.57227 2.51094L2.57227 4.06494Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardIcon);
export default __webpack_public_path__ + "static/media/GuardIcon.86c1cf229f6c9fedb2daa46d4683b46a.svg";
export { ForwardRef as ReactComponent };